import { SHIPMENT_SOLUTION_TYPES } from "~/cores/shipment.core";
import { createProductsAndExchangeToProductsFn, createReturnReasonConfigBottom, createReturnReasonConfigTop } from "../mockCore"; //
//
// export function getExchange({productId}) {
//     if (productId === "1") {
//         return {
//             "exchangeAlternatives": [
//                 {
//                     "id": "1",
//                     "imageUrl": "/mocks/Tights - Macchiato.jpeg",
//                     "inventoryMerchant": 1,
//                     "inventoryTurnr": 1,
//                     "inventoryTotal": 2,
//                     "properties": [
//                         {
//                             "type": "Color",
//                             "value": "Macchiato"
//                         },
//                         {
//                             "type": "Size",
//                             "value": "XS"
//                         }
//                     ]
//                 },
//                 {
//                     "id": "2",
//                     "imageUrl": "/mocks/Tights - Macchiato.jpeg",
//                     "inventoryMerchant": 1,
//                     "inventoryTurnr": 0,
//                     "inventoryTotal": 1,
//                     "properties": [
//                         {
//                             "type": "Color",
//                             "value": "Macchiato"
//                         },
//                         {
//                             "type": "Size",
//                             "value": "M"
//                         }
//                     ]
//                 },
//                 {
//                     "id": "3",
//                     "imageUrl": "/mocks/Tights - Dusty violet.jpeg",
//                     "inventoryMerchant": 1,
//                     "inventoryTurnr": 0,
//                     "inventoryTotal": 1,
//                     "properties": [
//                         {
//                             "type": "Color",
//                             "value": "Dusty violet"
//                         },
//                         {
//                             "type": "Size",
//                             "value": "S"
//                         }
//                     ]
//                 },
//                 {
//                     "id": "4",
//                     "imageUrl": "/mocks/Tights - Dusty violet.jpeg",
//                     "inventoryMerchant": 2,
//                     "inventoryTurnr": 1,
//                     "inventoryTotal": 1,
//                     "properties": [
//                         {
//                             "type": "Color",
//                             "value": "Dusty violet"
//                         },
//                         {
//                             "type": "Size",
//                             "value": "XS"
//                         }
//                     ]
//                 },
//                 {
//                     "id": "5",
//                     "imageUrl": "/mocks/Tights - Beige.jpeg",
//                     "inventoryMerchant": 1,
//                     "inventoryTurnr": 1,
//                     "inventoryTotal": 1,
//                     "properties": [
//                         {
//                             "type": "Color",
//                             "value": "Beige"
//                         },
//                         {
//                             "type": "Size",
//                             "value": "S"
//                         }
//                     ]
//                 },
//                 {
//                     "id": "6",
//                     "imageUrl": "/mocks/Tights - Beige.jpeg",
//                     "inventoryMerchant": 1,
//                     "inventoryTurnr": 1,
//                     "inventoryTotal": 1,
//                     "properties": [
//                         {
//                             "type": "Color",
//                             "value": "Beige"
//                         },
//                         {
//                             "type": "Size",
//                             "value": "M"
//                         }
//                     ]
//                 },
//                 {
//                     "id": "7",
//                     "imageUrl": "/mocks/Tights - Navy.jpeg",
//                     "inventoryMerchant": 1,
//                     "inventoryTurnr": 1,
//                     "inventoryTotal": 1,
//                     "properties": [
//                         {
//                             "type": "Color",
//                             "value": "Navy"
//                         },
//                         {
//                             "type": "Size",
//                             "value": "XS"
//                         }
//                     ]
//                 },
//                 {
//                     "id": "8",
//                     "imageUrl": "/mocks/Tights - Espresso.jpeg",
//                     "inventoryMerchant": 1,
//                     "inventoryTurnr": 1,
//                     "inventoryTotal": 1,
//                     "properties": [
//                         {
//                             "type": "Color",
//                             "value": "Espresso"
//                         },
//                         {
//                             "type": "Size",
//                             "value": "XS"
//                         }
//                     ]
//                 },
//                 {
//                     "id": "9",
//                     "imageUrl": "/mocks/Tights - Espresso.jpeg",
//                     "inventoryMerchant": 1,
//                     "inventoryTurnr": 1,
//                     "inventoryTotal": 1,
//                     "properties": [
//                         {
//                             "type": "Color",
//                             "value": "Espresso"
//                         },
//                         {
//                             "type": "Size",
//                             "value": "M"
//                         }
//                     ]
//                 }
//             ]
//         }
//     }
//     if (productId === "2") {
//         return {
//             "exchangeAlternatives": [
//                 {
//                     "id": "1",
//                     "imageUrl": "/mocks/Sports bra - Espresso.jpeg",
//                     "inventoryMerchant": 1,
//                     "inventoryTurnr": 1,
//                     "inventoryTotal": 2,
//                     "properties": [
//                         {
//                             "type": "Color",
//                             "value": "Espresso"
//                         },
//                         {
//                             "type": "Size",
//                             "value": "S"
//                         }
//                     ]
//                 },
//                 {
//                     "id": "2",
//                     "imageUrl": "/mocks/Sports bra - Espresso.jpeg",
//                     "inventoryMerchant": 0,
//                     "inventoryTurnr": 1,
//                     "inventoryTotal": 1,
//                     "properties": [
//                         {
//                             "type": "Color",
//                             "value": "Espresso"
//                         },
//                         {
//                             "type": "Size",
//                             "value": "M"
//                         }
//                     ]
//                 },
//                 {
//                     "id": "3",
//                     "imageUrl": "/mocks/Sports bra - Ocean Washed.jpeg",
//                     "inventoryMerchant": 1,
//                     "inventoryTurnr": 0,
//                     "inventoryTotal": 0,
//                     "properties": [
//                         {
//                             "type": "Color",
//                             "value": "Ocean Washed"
//                         },
//                         {
//                             "type": "Size",
//                             "value": "XS"
//                         }
//                     ]
//                 },
//                 {
//                     "id": "4",
//                     "imageUrl": "/mocks/Sports bra - Ocean Washed.jpeg",
//                     "inventoryMerchant": 1,
//                     "inventoryTurnr": 1,
//                     "inventoryTotal": 2,
//                     "properties": [
//                         {
//                             "type": "Color",
//                             "value": "Ocean Washed"
//                         },
//                         {
//                             "type": "Size",
//                             "value": "S"
//                         }
//                     ]
//                 },
//                 {
//                     "id": "5",
//                     "imageUrl": "/mocks/Sports bra - Ocean Washed.jpeg",
//                     "inventoryMerchant": 0,
//                     "inventoryTurnr": 1,
//                     "inventoryTotal": 1,
//                     "properties": [
//                         {
//                             "type": "Color",
//                             "value": "Ocean Washed"
//                         },
//                         {
//                             "type": "Size",
//                             "value": "M"
//                         }
//                     ]
//                 },
//                 {
//                     "id": "6",
//                     "imageUrl": "/mocks/Sports bra - Beige.jpeg",
//                     "inventoryMerchant": 1,
//                     "inventoryTurnr": 1,
//                     "inventoryTotal": 2,
//                     "properties": [
//                         {
//                             "type": "Color",
//                             "value": "Beige"
//                         },
//                         {
//                             "type": "Size",
//                             "value": "XS"
//                         }
//                     ]
//                 },
//                 {
//                     "id": "7",
//                     "imageUrl": "/mocks/Sports bra - Beige.jpeg",
//                     "inventoryMerchant": 1,
//                     "inventoryTurnr": 0,
//                     "inventoryTotal": 1,
//                     "properties": [
//                         {
//                             "type": "Color",
//                             "value": "Beige"
//                         },
//                         {
//                             "type": "Size",
//                             "value": "S"
//                         }
//                     ]
//                 }
//             ]
//         }
//     }
//     if (productId === "3") {
//         return {
//             "exchangeAlternatives": [
//                 {
//                     "id": "1",
//                     "imageUrl": "/mocks/Long Sleeve - Dusty violet.jpeg",
//                     "inventoryMerchant": 1,
//                     "inventoryTurnr": 1,
//                     "inventoryTotal": 2,
//                     "properties": [
//                         {
//                             "type": "Color",
//                             "value": "Dusty violet"
//                         },
//                         {
//                             "type": "Size",
//                             "value": "XS"
//                         }
//                     ]
//                 },
//                 {
//                     "id": "2",
//                     "imageUrl": "/mocks/Long Sleeve - Dusty violet.jpeg",
//                     "inventoryMerchant": 1,
//                     "inventoryTurnr": 0,
//                     "inventoryTotal": 1,
//                     "properties": [
//                         {
//                             "type": "Color",
//                             "value": "Dusty violet"
//                         },
//                         {
//                             "type": "Size",
//                             "value": "M"
//                         }
//                     ]
//                 },
//                 {
//                     "id": "3",
//                     "imageUrl": "/mocks/Long Sleeve - Beige.jpeg",
//                     "inventoryMerchant": 1,
//                     "inventoryTurnr": 0,
//                     "inventoryTotal": 1,
//                     "properties": [
//                         {
//                             "type": "Color",
//                             "value": "Beige"
//                         },
//                         {
//                             "type": "Size",
//                             "value": "S"
//                         }
//                     ]
//                 },
//                 {
//                     "id": "4",
//                     "imageUrl": "/mocks/Long Sleeve - Beige.jpeg",
//                     "inventoryMerchant": 2,
//                     "inventoryTurnr": 1,
//                     "inventoryTotal": 1,
//                     "properties": [
//                         {
//                             "type": "Color",
//                             "value": "Beige"
//                         },
//                         {
//                             "type": "Size",
//                             "value": "XS"
//                         }
//                     ]
//                 },
//                 {
//                     "id": "5",
//                     "imageUrl": "/mocks/Long Sleeve - Beige.jpeg",
//                     "inventoryMerchant": 1,
//                     "inventoryTurnr": 1,
//                     "inventoryTotal": 1,
//                     "properties": [
//                         {
//                             "type": "Color",
//                             "value": "Beige"
//                         },
//                         {
//                             "type": "Size",
//                             "value": "M"
//                         }
//                     ]
//                 },
//                 {
//                     "id": "6",
//                     "imageUrl": "/mocks/Long Sleeve - Black.jpeg",
//                     "inventoryMerchant": 1,
//                     "inventoryTurnr": 1,
//                     "inventoryTotal": 1,
//                     "properties": [
//                         {
//                             "type": "Color",
//                             "value": "Black"
//                         },
//                         {
//                             "type": "Size",
//                             "value": "M"
//                         }
//                     ]
//                 },
//                 {
//                     "id": "7",
//                     "imageUrl": "/mocks/Long Sleeve - Black.jpeg",
//                     "inventoryMerchant": 1,
//                     "inventoryTurnr": 1,
//                     "inventoryTotal": 1,
//                     "properties": [
//                         {
//                             "type": "Color",
//                             "value": "Black"
//                         },
//                         {
//                             "type": "Size",
//                             "value": "XS"
//                         }
//                     ]
//                 },
//                 {
//                     "id": "8",
//                     "imageUrl": "/mocks/Long Sleeve - Black.jpeg",
//                     "inventoryMerchant": 1,
//                     "inventoryTurnr": 1,
//                     "inventoryTotal": 1,
//                     "properties": [
//                         {
//                             "type": "Color",
//                             "value": "Black"
//                         },
//                         {
//                             "type": "Size",
//                             "value": "S"
//                         }
//                     ]
//                 },
//                 {
//                     "id": "9",
//                     "imageUrl": "/mocks/Long Sleeve - Black.jpeg",
//                     "inventoryMerchant": 1,
//                     "inventoryTurnr": 1,
//                     "inventoryTotal": 1,
//                     "properties": [
//                         {
//                             "type": "Color",
//                             "value": "Black"
//                         },
//                         {
//                             "type": "Size",
//                             "value": "L"
//                         }
//                     ]
//                 }
//             ]
//         }
//     }
//
//     return {
//         "exchangeAlternatives": [
//             {
//                 "id": "1",
//                 "inventoryMerchant": 1,
//                 "inventoryTurnr": 1,
//                 "inventoryTotal": 2,
//                 "properties": [
//                     {
//                         "type": "Color",
//                         "value": "Red"
//                     },
//                     {
//                         "type": "Size",
//                         "value": "M"
//                     }
//                 ]
//             },
//             {
//                 "id": "2",
//                 "inventoryMerchant": 1,
//                 "inventoryTurnr": 1,
//                 "inventoryTotal": 2,
//                 "properties": [
//                     {
//                         "type": "Color",
//                         "value": "Red"
//                     },
//                     {
//                         "type": "Size",
//                         "value": "L"
//                     }
//                 ]
//             },
//             {
//                 "id": "3",
//                 "inventoryMerchant": 0,
//                 "inventoryTurnr": 1,
//                 "inventoryTotal": 1,
//                 "properties": [
//                     {
//                         "type": "Color",
//                         "value": "White"
//                     },
//                     {
//                         "type": "Size",
//                         "value": "M"
//                     }
//                 ]
//             },
//             {
//                 "id": "4",
//                 "inventoryMerchant": 1,
//                 "inventoryTurnr": 1,
//                 "inventoryTotal": 0,
//                 "properties": [
//                     {
//                         "type": "Color",
//                         "value": "White"
//                     },
//                     {
//                         "type": "Size",
//                         "value": "M"
//                     }
//                 ]
//             },
//             {
//                 "id": "4",
//                 "inventoryMerchant": 1,
//                 "inventoryTurnr": 1,
//                 "inventoryTotal": 0,
//                 "properties": [
//                     {
//                         "type": "Color",
//                         "value": "Green"
//                     },
//                     {
//                         "type": "Size",
//                         "value": "M"
//                     }
//                 ]
//             }
//         ]
//     }
// }

const productData1 = {
    product: {
        productVariantId: 10,
        sessionItemId: 1,
        productName: "Ribbed Seamless Tights",
        imageSrc: "/mocks/Tights - Macchiato.jpeg",
        imageAlt: "/mocks/Tights - Macchiato.jpeg",
        quantity: 1,
        purchasePrice: 599,
        properties: [
            {
                type: "Size",
                value: "S",
            },
            {
                type: "Color",
                value: "Macchiato",
            },
        ],
        returnReasonConfig: createReturnReasonConfigBottom(),
    },
};
const productData2 = {
    product: {
        productVariantId: 20,
        sessionItemId: 2,
        productName: "Ribbed Seamless Bra",
        imageSrc: "/mocks/Sports bra - Espresso.jpeg",
        imageAlt: "/mocks/Sports bra - Espresso.jpeg",
        quantity: 1,
        purchasePrice: 349,
        properties: [
            {
                type: "Color",
                value: "Espresso",
            },
            {
                type: "Size",
                value: "XS",
            },
        ],
        returnReasonConfig: createReturnReasonConfigTop(),
    },
};
const productData3 = {
    product: {
        productVariantId: 30,
        sessionItemId: 3,
        productName: "Seamless Crop Long Sleeve",
        imageSrc: "/mocks/Long Sleeve - Dusty violet.jpeg",
        imageAlt: "/mocks/Long Sleeve - Dusty violet.jpeg",
        quantity: 1,
        purchasePrice: 549,
        properties: [
            {
                type: "Size",
                value: "S",
            },
            {
                type: "Color",
                value: "Dusty violet",
            },
        ],
        returnReasonConfig: createReturnReasonConfigTop(),
    },
};

const productsAndExchangeToProductsFn = createProductsAndExchangeToProductsFn([productData1, productData2, productData3]);

export function getExchangeToProducts({ productId }) {
    return productsAndExchangeToProductsFn.exchangeToProductsFn({ productId });
}

export function getProducts() {
    return {
        sessionId: "170bfc7b-8910-43a7-8903-52c9894ed015",
        shipmentSolutions: [
            {
                carrier: "DOORIS",
                type: SHIPMENT_SOLUTION_TYPES.PICKUP.key,
                cost: 0,
            },
            {
                carrier: "BUDBEE",
                type: SHIPMENT_SOLUTION_TYPES.PICKUP.key,
                cost: 39,
            },
            {
                carrier: "POSTNORD",
                type: SHIPMENT_SOLUTION_TYPES.PRINT_LABEL.key,
                cost: 39,
            },
        ],
        pickupDateSelectionAllowed: true,
        paidShipping: 40,
        turnrShippingCost: 59,
        currencyCode: "NOK",
        refundOptions: [
            {
                type: "BASIC",
            },
            {
                type: "GIFT_CARD",
                bonusPercentage: 0.2,
            },
        ],
        products: productsAndExchangeToProductsFn.products,
    };
}
